/**
 * Created by iamso on 05.11.2020.
 */

cleverapps.UI.ScrollHandler = function (target, options) {
    options = options || {};
    this.target = target;
    this.bounceEnabled = options.bounceEnabled !== false;
    this.outOfBoundaryScale = options.outOfBoundaryScale === undefined ? 0.5 : options.outOfBoundaryScale;
    this.inertialScrollFactor = options.inertialScrollFactor || 1;
    this.snapHandler = options.snapHandler;
    this.movementThreshold = options.movementThreshold;

    this.initAutoScrollParams();
    if (options.mouseScroll !== false) {
        this.enableMouseWheelScroll();
    }
    if (options.touchScroll !== false) {
        this.enableTouchScroll();
    }
};

cleverapps.UI.ScrollHandler.prototype.enableMouseWheelScroll = function () {
    this.scrollHandler = cleverapps.pointerManager.create(this.target, {
        onMouseScroll: this.handleMouseWheel.bind(this)
    });
};

cleverapps.UI.ScrollHandler.prototype.handleMouseWheel = function (dy, dx) {
    dx = dx || 0;

    // eslint-disable-next-line no-bitwise
    if ((this.target.direction & cleverapps.UI.ScrollView.DIR_HORIZONTAL) === 0) {
        dx = 0;
    }
    // eslint-disable-next-line no-bitwise
    if ((this.target.direction & cleverapps.UI.ScrollView.DIR_VERTICAL) === 0) {
        dy = 0;
    }

    if (dy === 0 && dx === 0) {
        return;
    }

    // A notched wheel delivers one big delta per click, so each click is turned into an
    // inertial kick. A trackpad delivers a stream of small deltas at pointer rate: kicking
    // off an animation per event makes it lurch, so those move the container directly and
    // the gesture itself provides the smoothness. Horizontal deltas only come from precise
    // devices, so any dx puts the whole event on the direct path.
    if (dx !== 0 || Math.abs(dy) < cleverapps.styles.ScrollHandler.notchedWheelDelta) {
        this.stopAutoScroll();
        this.mouseWheelSpeed = 0;
        this.lastMouseWheelTime = Date.now();
        this.moveContainer(this.target.normalizePoint(cc.pAdd(this.target.getContainerPosition(), this.getWheelDelta(dx, dy))));
        return;
    }

    const dir = dy > 0 ? 1 : -1;
    const outOfBoundary = this.getHowMuchOutOfBoundary({ y: dir });
    if (!this.fltEqualZero(outOfBoundary)) {
        if (outOfBoundary.y < 0 && dy > 0 || outOfBoundary.y > 0 && dy < 0) {
            return;
        }
    }

    if (this.lastMouseWheelTime && this.lastMouseWheelTime > Date.now() - 100) {
        return;
    }

    if (!this.mouseWheelSpeed || this.lastMouseWheelTime < Date.now() - 500 || dy * this.mouseWheelSpeed < 0) {
        this.mouseWheelSpeed = 0;
    }

    this.mouseWheelSpeed += cleverapps.styles.ScrollHandler.mouseWheelAcceleration * cleverapps.sign(dy);
    if (Math.abs(this.mouseWheelSpeed) > cleverapps.styles.ScrollHandler.mouseWheelMaxSpeed) {
        this.mouseWheelSpeed = cleverapps.sign(this.mouseWheelSpeed) * cleverapps.styles.ScrollHandler.mouseWheelMaxSpeed;
    }
    if (Math.abs(this.mouseWheelSpeed) < cleverapps.styles.ScrollHandler.mouseWheelMinSpeed) {
        this.mouseWheelSpeed = cleverapps.sign(this.mouseWheelSpeed) * cleverapps.styles.ScrollHandler.mouseWheelMinSpeed;
    }

    this.startInertialScroll(cc.p(0, this.mouseWheelSpeed));

    this.lastMouseWheelTime = Date.now();
};

cleverapps.UI.ScrollHandler.prototype.enableTouchScroll = function () {
    cleverapps.UI.onDrag(this.target, {
        dragDirection: true,
        onDragStart: this.onTouchBegan.bind(this),
        onDragMoveNotThrottled: this.onTouchMoved.bind(this),
        onDragEnd: this.onTouchEnded.bind(this)
    });
};

cleverapps.UI.ScrollHandler.prototype.onTouchBegan = function (touch) {
    this.stopAutoScroll();

    if (this.target.touchScrollDisabled) {
        return false;
    }

    this.target.stopScrollAction();
    this.handlePress(touch);
    return true;
};

cleverapps.UI.ScrollHandler.prototype.onTouchMoved = function (touch) {
    if (this.target.touchScrollDisabled) {
        return;
    }

    this.handleMove(touch);
};

cleverapps.UI.ScrollHandler.prototype.onTouchEnded = function (touch) {
    if (this.target.touchScrollDisabled) {
        return;
    }

    this.handleRelease(touch);
};

cleverapps.UI.ScrollHandler.prototype.getTouchDelta = function (touch, onTouchEnd) {
    let point = this.target.convertToNodeSpace(touch.getLocation());
    const prevPoint = this.target.convertToNodeSpace(touch.getPreviousLocation());
    if (onTouchEnd && !cc.rectContainsPoint(cc.rect(0, 0, this.target.width, this.target.height), point)) {
        point = prevPoint;
    }
    const delta = cc.pMult(cc.pSub(prevPoint, point), 1 / this.target.zoom);
    // eslint-disable-next-line no-bitwise
    if ((this.target.direction & cleverapps.UI.ScrollView.DIR_HORIZONTAL) === 0) {
        delta.x = 0;
    }
    // eslint-disable-next-line no-bitwise
    if ((this.target.direction & cleverapps.UI.ScrollView.DIR_VERTICAL) === 0) {
        delta.y = 0;
    }
    return delta;
};

// Wheel deltas arrive in scene units; the container lives under whatever scaling the
// scroll and its ancestors carry, so measure the same shift there, the way drags do.
cleverapps.UI.ScrollHandler.prototype.getWheelDelta = function (dx, dy) {
    const origin = this.target.convertToNodeSpace(cc.p(0, 0));
    const shifted = this.target.convertToNodeSpace(cc.p(dx, dy));

    return cc.pMult(cc.pSub(shifted, origin), 1 / this.target.zoom);
};

cleverapps.UI.ScrollHandler.prototype.initAutoScrollParams = function () {
    this._outOfBoundaryAmountDirty = true;
    this._outOfBoundaryAmount = cc.p(0, 0);
};

cleverapps.UI.ScrollHandler.prototype.afterContainerScale = function () {
    this._outOfBoundaryAmountDirty = true;

    const outOfBoundary = this.getHowMuchOutOfBoundary();
    if (!this.fltEqualZero(outOfBoundary)) {
        this.startAutoScroll(outOfBoundary, 0);
    }
};

cleverapps.UI.ScrollHandler.prototype.afterContainerMove = function () {
    this._outOfBoundaryAmountDirty = true;

    if (this.target.barHandler) {
        this.target.barHandler.updatePos();
    }
    if (this.bounceEnabled && !this.inTouch && !this._autoScrolling) {
        this.startBounceBackIfNeeded();
    }
};

cleverapps.UI.ScrollHandler.prototype.startBounceBackIfNeeded = function () {
    if (!this.bounceEnabled) {
        return false;
    }
    const bounceBackAmount = this.getHowMuchOutOfBoundary();
    if (this.fltEqualZero(bounceBackAmount)) {
        return false;
    }
    const BOUNCE_BACK_DURATION = 1.0;
    this.startAutoScroll(bounceBackAmount, BOUNCE_BACK_DURATION);
    return true;
};

cleverapps.UI.ScrollHandler.prototype.handlePress = function (touch) {
    this.inTouch = true;

    this.stopAutoScroll();

    this._touchMovePreviousTimestamp = touch.getLastModified();
    this._touchMoveDisplacements = [];
    this._touchMoveTimeDeltas = [];
    this._skipDragStartSample = true;

    if (this.target.barHandler) {
        this.target.barHandler.onTouchBegan();
    }
};

cleverapps.UI.ScrollHandler.prototype.handleMove = function (touch) {
    const point = this.target.convertToNodeSpace(touch.getLocation());
    const prevPoint = this.target.convertToNodeSpace(touch.getPreviousLocation());
    const rawDelta = cc.pSub(prevPoint, point);

    if (this.movementThreshold && Math.abs(rawDelta.x) < this.movementThreshold && Math.abs(rawDelta.y) < this.movementThreshold) {
        return;
    }

    const delta = this.getTouchDelta(touch);

    let outOfBoundary;

    if (this.bounceEnabled) {
        outOfBoundary = this.getHowMuchOutOfBoundary(delta);
        delta.x *= (outOfBoundary.x === 0 ? 1 : this.outOfBoundaryScale);
        delta.y *= (outOfBoundary.y === 0 ? 1 : this.outOfBoundaryScale);
    } else {
        outOfBoundary = this.getHowMuchOutOfBoundary(delta);
        delta.x += outOfBoundary.x;
        delta.y += outOfBoundary.y;
    }

    this.gatherMoveData(delta, touch);

    const newPos = cc.pAdd(this.target.getContainerPosition(), delta);
    this.moveContainer(newPos);
};

cleverapps.UI.ScrollHandler.prototype.gatherMoveData = function (deltaMove, touch) {
    // The move that starts the drag is not a velocity sample. onDragStart and the first
    // onDragMoveNotThrottled fire from the same event (pointerhandler.js:513-527), so its
    // timestamp is the one handlePress just stored: the displacement that crossed the drag
    // threshold would enter the numerator with no elapsed time to divide it by. That
    // displacement accumulated over the whole press-to-threshold interval anyway, which is
    // not the gap since a previous move, so it says nothing about the pointer's speed.
    if (this._skipDragStartSample) {
        this._skipDragStartSample = false;
        this._touchMovePreviousTimestamp = touch.getLastModified();
        return;
    }

    while (this._touchMoveDisplacements.length >= 5) {
        this._touchMoveDisplacements.splice(0, 1);
        this._touchMoveTimeDeltas.splice(0, 1);
    }
    this._touchMoveDisplacements.push(deltaMove);

    const timestamp = touch.getLastModified();
    this._touchMoveTimeDeltas.push((timestamp - this._touchMovePreviousTimestamp) / 1000);
    this._touchMovePreviousTimestamp = timestamp;
};

cleverapps.UI.ScrollHandler.prototype.handleRelease = function (touch) {
    this.inTouch = false;

    const deltaMove = this.getTouchDelta(touch, true);

    this.gatherMoveData(deltaMove, touch);

    if (this.snapHandler) {
        this.startAutoScroll(this.snapHandler(this.calcTouchVelocity().y > 0 || this.calcTouchVelocity().x > 0), this.snapDuration);
    } else {
        const bounceBackStarted = this.startBounceBackIfNeeded();
        if (!bounceBackStarted) {
            const touchVelocity = this.calcTouchVelocity();
            if (touchVelocity.x !== 0 || touchVelocity.y !== 0) {
                this.startInertialScroll(touchVelocity);
            }
        }
    }

    if (this.target.barHandler) {
        this.target.barHandler.onTouchEnded();
    }
};

cleverapps.UI.ScrollHandler.prototype.calcAutoScrollPercentage = function () {
    let percentage = this._autoScrollAccumulatedTime < this._autoScrollTotalTime ? this._autoScrollAccumulatedTime / this._autoScrollTotalTime : 1;
    if (this._autoScrollAttenuate) {
        percentage -= 1;
        percentage = percentage * percentage * percentage * percentage * percentage + 1;
    }
    return percentage;
};

cleverapps.UI.ScrollHandler.prototype.processAutoScroll = function (deltaTime) {
    if (!this._autoScrolling || this.inTouch) {
        return;
    }

    const OUT_OF_BOUNDARY_BREAKING_FACTOR = 0.05;
    let brakingFactor = 1;
    let percentage = this.calcAutoScrollPercentage();
    if (percentage >= 0 && percentage <= 1 && this.isNecessaryAutoScrollBrake()) {
        brakingFactor = OUT_OF_BOUNDARY_BREAKING_FACTOR;
    }

    this._autoScrollAccumulatedTime += deltaTime * (1 / brakingFactor);

    percentage = this.calcAutoScrollPercentage();

    const reachedEnd = Math.abs(percentage - 1) <= 0.0001;
    if (reachedEnd) {
        percentage = 1;
        this.stopAutoScroll();
    }

    let newPosition = cc.pAdd(this._autoScrollStartPosition, cc.pMult(this._autoScrollTargetDelta, percentage));
    newPosition = cc.pAdd(this._autoScrollBrakingStartPosition, cc.pMult(cc.pSub(newPosition, this._autoScrollBrakingStartPosition), brakingFactor));

    this.moveContainer(newPosition);
};

cleverapps.UI.ScrollHandler.prototype.moveContainer = function (newPos) {
    this.target.scrollToPoint(newPos);

    this.afterContainerMove();
};

cleverapps.UI.ScrollHandler.prototype.isOutOfBoundary = function () {
    const outOfBoundary = this.getHowMuchOutOfBoundary();
    return !this.fltEqualZero(outOfBoundary);
};

cleverapps.UI.ScrollHandler.prototype.calcTouchVelocity = function () {
    const totalTime = this._touchMoveTimeDeltas.reduce((a, b) => a + b, 0);
    if (totalTime === 0 || totalTime >= 0.5) {
        return cc.p(0, 0);
    }

    const totalMovement = cc.p(0, 0);
    this._touchMoveDisplacements.forEach((point) => {
        totalMovement.x += point.x;
        totalMovement.y += point.y;
    });

    // The samples can span far less than a frame: the browser flushes a pending pointermove
    // microseconds before the pointerup, so a gesture that ends while the pointer is still
    // moving leaves two samples a fraction of a millisecond apart. Dividing by that raw span
    // turns a few pixels of click jitter into thousands of pixels of inertia, so bound it -
    // the pointer cannot have travelled this far in less than one frame of input.
    const MIN_VELOCITY_TIME = 1 / 60;

    return cc.pMult(totalMovement, 1 / Math.max(totalTime, MIN_VELOCITY_TIME));
};

cleverapps.UI.ScrollHandler.prototype.isNecessaryAutoScrollBrake = function () {
    if (this._autoScrollBraking) {
        return true;
    }

    if (this.isOutOfBoundary()) {
        if (!this._autoScrollCurrentlyOutOfBoundary) {
            this._autoScrollCurrentlyOutOfBoundary = true;
            this._autoScrollBraking = true;
            this._autoScrollBrakingStartPosition = this.target.getContainerPosition();
            return true;
        }
    } else {
        this._autoScrollCurrentlyOutOfBoundary = false;
    }
    return false;
};

cleverapps.UI.ScrollHandler.prototype.startInertialScroll = function (touchVelocity) {
    const MOVEMENT_FACTOR = 0.7 * this.inertialScrollFactor;
    const inertiaTotalMovement = cc.pMult(touchVelocity, MOVEMENT_FACTOR);

    let time = this.calculateAutoScrollTimeByInitialSpeed(cc.pLength(touchVelocity));

    if (!this.bounceEnabled) {
        const outOfBoundary = this.getHowMuchOutOfBoundary(inertiaTotalMovement);
        if (!this.fltEqualZero(outOfBoundary)) {
            const originalLength = cc.pLength(inertiaTotalMovement);
            inertiaTotalMovement.x += outOfBoundary.x;
            inertiaTotalMovement.y += outOfBoundary.y;
            if (originalLength > 0) {
                time *= cc.pLength(inertiaTotalMovement) / originalLength;
            }
        }
    }

    this.startAutoScroll(inertiaTotalMovement, time);
};

cleverapps.UI.ScrollHandler.prototype.calculateAutoScrollTimeByInitialSpeed = function (initialSpeed) {
    return Math.sqrt(Math.sqrt(initialSpeed / 5)) * this.inertialScrollFactor;
};

cleverapps.UI.ScrollHandler.prototype.fltEqualZero = function (point) {
    return (Math.abs(point.x) <= 0.0001 && Math.abs(point.y) <= 0.0001);
};

cleverapps.UI.ScrollHandler.prototype.startAutoScroll = function (deltaMove, timeInSec) {
    this._autoScrolling = true;
    this._autoScrollTargetDelta = deltaMove;
    this._autoScrollAttenuate = true;
    this._autoScrollStartPosition = this.target.getContainerPosition();
    this._autoScrollTotalTime = timeInSec;
    this._autoScrollAccumulatedTime = 0;
    this._autoScrollBraking = false;
    this._autoScrollBrakingStartPosition = cc.p(0, 0);

    const currentOutOfBoundary = this.getHowMuchOutOfBoundary();
    if (!this.fltEqualZero(currentOutOfBoundary)) {
        this._autoScrollCurrentlyOutOfBoundary = true;
        const afterOutOfBoundary = this.getHowMuchOutOfBoundary(deltaMove);
        if (currentOutOfBoundary.x * afterOutOfBoundary.x > 0 || currentOutOfBoundary.y * afterOutOfBoundary.y > 0) {
            this._autoScrollBraking = true;
            this._autoScrollBrakingStartPosition = this.target.getContainerPosition();
        }
    }
};

cleverapps.UI.ScrollHandler.prototype.stopAutoScroll = function () {
    this._autoScrolling = false;
};

cleverapps.UI.ScrollHandler.prototype.getHowMuchOutOfBoundary = function (deltaMove) {
    if (deltaMove === undefined) {
        deltaMove = cc.p(0, 0);
    }

    if (deltaMove.x === 0 && deltaMove.y === 0 && !this._outOfBoundaryAmountDirty) {
        return this._outOfBoundaryAmount;
    }

    const outOfBoundaryAmount = cc.p(0, 0);
    const contPos = this.target.getContainerPosition();

    if (contPos.x + deltaMove.x > this.target.max.x) {
        outOfBoundaryAmount.x = this.target.max.x - (contPos.x + deltaMove.x);
    } else if (contPos.x + deltaMove.x < this.target.min.x) {
        outOfBoundaryAmount.x = this.target.min.x - (contPos.x + deltaMove.x);
    }

    if (contPos.y + deltaMove.y < this.target.min.y) {
        outOfBoundaryAmount.y = this.target.min.y - (contPos.y + deltaMove.y);
    } else if (contPos.y + deltaMove.y > this.target.max.y) {
        outOfBoundaryAmount.y = this.target.max.y - (contPos.y + deltaMove.y);
    }

    if (deltaMove.x === 0 && deltaMove.y === 0) {
        this._outOfBoundaryAmount = outOfBoundaryAmount;
        this._outOfBoundaryAmountDirty = false;
    }
    return outOfBoundaryAmount;
};

cleverapps.UI.ScrollHandler.prototype.isProcessing = function () {
    return this.inTouch || this._autoScrolling;
};

cleverapps.UI.ScrollHandler.prototype.setSnapHandler = function (snapHandler, snapDuration) {
    this.snapHandler = snapHandler;
    this.snapDuration = snapDuration;
};

cleverapps.styles.ScrollHandler = {
    mouseWheelAcceleration: 200,
    mouseWheelMinSpeed: 500,
    mouseWheelMaxSpeed: 2000,

    // Smallest wheel delta still treated as a notch click. Notched wheels report ~100
    // per click; trackpads and free-spinning wheels stay well below it.
    notchedWheelDelta: 65
};
